import { SimpleError } from '@common/errors';
function wrapPlainFilter(filter) {
    if (typeof filter === 'string' || typeof filter === 'number' || typeof filter === 'boolean' || filter === null || filter === undefined || filter instanceof Date) {
        return {
            $eq: filter,
        };
    }
    // Magic values
    if (typeof filter === 'object' && '$' in filter) {
        return {
            $eq: filter,
        };
    }
    return filter;
}
export const filterDefinitionsToSelector = filterDefinitionsToCompiler;
export function filterDefinitionsToCompiler(definitions) {
    return (filter, parentCompiler, key) => {
        let k = definitions[key];
        if (!k) {
            const dotIndex = key.indexOf('.');
            if (dotIndex !== -1) {
                // todo: first search for first match + adjust filter
                const firstKey = key.substring(0, dotIndex);
                const k = definitions[firstKey];
                if (!k) {
                    throw new SimpleError({
                        code: 'unknown_filter',
                        message: 'Unknown filter ' + key,
                    });
                }
                const subKey = key.substring(dotIndex + 1);
                if (typeof k === 'function') {
                    return k({ [subKey]: filter }, parentCompiler, firstKey);
                }
                const subCompiler = filterDefinitionsToCompiler(k);
                return subCompiler(filter, subCompiler, subKey);
            }
            if (definitions['*'] && !key.startsWith('$')) {
                k = definitions['*'];
            }
        }
        if (typeof k === 'function') {
            return k(filter, parentCompiler, key);
        }
        if (typeof k === 'object') {
            // Create a namespace compiler
            const subCompiler = filterDefinitionsToCompiler(k);
            return subCompiler(filter, subCompiler, '$and');
        }
        return undefined;
    };
}
export function compileFilter(filter, parentCompiler) {
    if (filter === undefined) {
        return [];
    }
    const runners = [];
    if (Array.isArray(filter)) {
        // we combine these filters and and children
        for (const subFilter of filter) {
            const runner = parentCompiler(subFilter, parentCompiler, '$and');
            if (runner === undefined) {
                throw new SimpleError({
                    code: 'unknown_filter',
                    message: 'Unknown filter $and',
                });
            }
            runners.push(runner);
        }
    }
    else {
        const f = wrapPlainFilter(filter);
        for (const key of Object.keys(f)) {
            const subFilter = f[key];
            const runner = parentCompiler(subFilter, parentCompiler, key);
            if (runner === undefined) {
                throw new SimpleError({
                    code: 'unknown_filter',
                    message: 'Unknown filter ' + key,
                });
            }
            runners.push(runner);
        }
    }
    return runners;
}
export function getMagicValue(value) {
    const specialValue = value['$'];
    switch (specialValue) {
        case '$now': return value;
        case '$rel': return getMagicRelationValue(value);
        default: throw new SimpleError({
            code: 'unknown_filter',
            message: 'Unknown magic filter ' + specialValue,
        });
    }
}
export function isMagicFilter(value) {
    if (value === null) {
        return false;
    }
    if (typeof value === 'object' && '$' in value) {
        return true;
    }
    return false;
}
export function isMagicRelationFilter(value) {
    if (!isMagicFilter(value)) {
        return false;
    }
    const specialValue = value['$'];
    return specialValue === '$rel';
}
export function getMagicRelationValue(value) {
    return assertFilterCompareValue(value['value']);
}
/**
 * Asserts val is StamhoofdCompareValue
 */
export function assertFilterCompareValue(val) {
    if (val instanceof Date) {
        return val;
    }
    if (typeof val === 'string') {
        return val;
    }
    if (typeof val === 'number') {
        return val;
    }
    if (typeof val === 'boolean') {
        return val;
    }
    if (val === null) {
        return null;
    }
    if (isMagicFilter(val)) {
        return getMagicValue(val);
    }
    console.error('Invalid compare value. Expected a string, number, boolean, date or null.', val);
    throw new Error('Invalid compare value. Expected a string, number, boolean, date or null.');
}
//# sourceMappingURL=FilterCompilers.js.map